export const patna = {
 // 0: "Select Bench",
  1: "Principal Bench Patna"
};

export const madras = {
 // 0: "Select Bench",
  1: "Madras High Court",
  2: "Madurai Bench of Madras High Court"
};

export const uttarakhand = {
 // 0: "Select Bench",
  1: "High Court of Uttarakhand",
};

export const tripura = {
 // 0: "Select Bench",
  1: "High Court of Tripura",
};

export const sikkim = {
 // 0: "Select Bench",
  1: "High Court of Sikkim",
};

export const rajasthan = {
 // 0: "Select Bench",
  1: "High Court Bench at Jaipur",
  2: "Rajasthan High Court Principal Seat Jodhpur"
};

export const punjabAndHaryana = {
 // 0: "Select Bench",
  1: "High Court of Punjab And Haryana",
};

export const orissa = {
 // 0: "Select Bench",
  1: "High Court of Orissa",
};

export const meghalaya = {
 // 0: "Select Bench",
  1: "High Court of Meghalaya",
};

export const manipur = {
 // 0: "Select Bench",
  1: "High Court of Manipur",
};

export const madhyaPradesh = {
 // 0: "Select Bench",
  3: "High Court Of Madhya Pradesh Gwalior",
  2: "High Court Of Madhya Pradesh Indore",
  1: "High Court Of Madhya Pradesh Jabalpur"
};
export const kerala = {
 // 0: "Select Bench",
  1: "High Court of Kerala",
};

export const karnataka = {
 // 0: "Select Bench",
  2: "Bench at Dharwad",
  3: "Bench at Kalburagi",
  1: "Principal Bench at Bengaluru"
};

export const jharkhand = {
 // 0: "Select Bench",
  1: "Principal Bench Jharkhand"
};

export const jammuKashmir = {
 // 0: "Select Bench",
  1: "Jammu Wing",
  2: "Srinagar Wing"
};

export const himachalPradesh = {
 // 0: "Select Bench",
  1: "High Court of Himachal Pradesh"
};

export const delhi = {
 // 0: "Select Bench",
  1: "Principal Bench at Delhi"
};

export const chhattisgarh = {
 // 0: "Select Bench",
  1: "Principal Bench Chhattisgarh"
};

export const andhraPradesh = {
 // 0: "Select Bench",
  1: "Principal Bench at Andhra Pradesh"
};

export const telangana = {
 // 0: "Select Bench",
  1: "Principal Bench at Hyderabad"
};

export const gauhati = {
 // 0: "Select Bench",
  3: "Aizawl Bench",
  4: "Itanagar Bench",
  2: "Kohima Bench",
  1: "Principal Seat at Guwahati"
};

export const calcutta = {
 // 0: "Select Bench",
  3: "Appellate side",
  2: "Circuit Bench At Jalpaiguri",
  4: "Circuit Bench At Port Blair",
  1: "Original Side"
};

export const bombay = {
  // 0: "Select Bench",
  1: "Appellate Side, Bombay",
  2: "Original Side, Bombay",
  3: "Bench at Aurangabad",
  4: "Bench at Nagpur",
  5: "High court of Bombay at Goa",
  6: "Special Court (TORTS) Bombay"
};

export const allahabad = {
  1: "Allahabad High Court",
  2: "Allahabad High Court Lucknow Bench"
};

export const gujarat = {
  1: "Gujarat High Court"
};

export const state = {
  13: { highCourt: "Allahabad High Court", benches: allahabad },
  1: { highCourt: "Bombay High Court", benches: bombay },
  16: { highCourt: "Calcutta High Court", benches: calcutta },
  6: { highCourt: "Gauhati High Court", benches: gauhati },
  29: { highCourt: "High Court for State of Telangana", benches: telangana },
  2: { highCourt: "High Court of Andhra Pradesh", benches: andhraPradesh },
  18: { highCourt: "High Court of Chhattisgarh", benches: chhattisgarh },
  26: { highCourt: "High Court of Delhi", benches: delhi },
  17: { highCourt: "High Court of Gujarat", benches: gujarat },
  5: { highCourt: "High Court of Himachal Pradesh", benches: himachalPradesh },
  12: { highCourt: "High Court of Jammu and Kashmir", benches: jammuKashmir },
  7: { highCourt: "High Court of Jharkhand", benches: jharkhand },
  3: { highCourt: "High Court of Karnataka", benches: karnataka },
  4: { highCourt: "High Court of Kerala", benches: kerala },
  23: { highCourt: "High Court of Madhya Pradesh", benches: madhyaPradesh },
  25: { highCourt: "High Court of Manipur", benches: manipur },
  21: { highCourt: "High Court of Meghalaya", benches: meghalaya },
  11: { highCourt: "High Court of Orissa", benches: orissa },
  22: { highCourt: "High Court of Punjab and Haryana", benches: punjabAndHaryana },
  9: { highCourt: "High Court of Rajasthan", benches: rajasthan },
  24: { highCourt: "High Court of Sikkim", benches: sikkim },
  20: { highCourt: "High Court of Tripura", benches: tripura },
  15: { highCourt: "High Court of Uttarakhand", benches: uttarakhand },
  10: { highCourt: "Madras High Court", benches: madras },
  8: { highCourt: "Patna High Court", benches: patna }
};